import { useMutation } from "react-query";
import { getCompletedInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetCompletedInvoiceById = () => {
  return useMutation(getCompletedInvoiceById);
};
